import React, { type ReactNode } from 'react';

interface Props {
  title: string;
  subtitle: string;
  leading?: ReactNode;
  trailing?: ReactNode;
  hasDivider?: boolean;
}

export const SettingRow: React.FC<Props> = ({
  title,
  subtitle,
  leading,
  trailing,
  hasDivider = false,
}) => (
  <div className="px-4">
    <div className="flex items-center gap-3 py-4">
      {leading}
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="text-body-14 text-foreground">{title}</p>
        {subtitle && (
          <p className="text-body-14 text-subtle-foreground">{subtitle}</p>
        )}
      </div>
      {trailing}
    </div>
    {hasDivider && <div className="h-px bg-divider" />}
  </div>
);
